import { render, staticRenderFns } from "./FiscalObligationsUpload.vue?vue&type=template&id=bd6877d8&"
import script from "./FiscalObligationsUpload.vue?vue&type=script&lang=js&"
export * from "./FiscalObligationsUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports